import { render, staticRenderFns } from "./ContentWrapper.vue?vue&type=template&id=140f0260&scoped=true&"
import script from "./ContentWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ContentWrapper.vue?vue&type=style&index=0&id=140f0260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f0260",
  null
  
)

export default component.exports